import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const BILLING_SUBSCRIPTION_CHANGE_MUTATION = gql`
  mutation BillingSubscriptionChange($input: SubscriptionChangeRequestInput!) {
    billingSubscriptionChange(input: $input) {
      statusCode
    }
  }
`;

export function useBillingSubscriptionChange() {
  const [submitChange, { data, loading, error }] = useMutation(
    BILLING_SUBSCRIPTION_CHANGE_MUTATION,
    { noThrow: true }
  );

  useError(error);

  const cancelSubscription = useCallback(
    (input) => submitChange({ variables: { input } }),
    [submitChange]
  );

  return {
    cancelSubscription,
    data: data?.billingSubscriptionChange,
    loading,
    error
  };
}
